import _extends from "@swc/helpers/src/_extends.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import React, { useState } from 'react';
import { AdProviders, adunitMemo, ADUNIT_FALLBACK_MAP, ADUNIT_MAP } from '../../../constants';
import { useAdUnit } from '../../../useAdUnit';
import IconButton from '@wix/da-ds/pkg/Buttons/IconButton';
import Close from '@wix/da-ds/pkg/Icons/16x16/Close';
import cn from 'classnames';
import DealerAdIframe from '../../dealer';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import adunitStyles from './adunits.scss';
const DesktopAdhesionGak = /*#__PURE__*/ React.memo(({ safety ='off'  })=>{
    const [hidden, setHidden] = useState(false);
    const isNsfgFallback = useFlag('ads_dealer_nsfg');
    const _useAdUnit = useAdUnit(AdProviders.Gak, ADUNIT_MAP['UserDesktopAdhesionGam'], safety, {
        refreshLimit: 30,
        refreshTimeout: 240000,
        size: [
            [
                320,
                50
            ],
            [
                728,
                90
            ],
            [
                970,
                90
            ]
        ],
        responsiveSizeMap: [
            [
                [
                    1440,
                    1
                ],
                [
                    [
                        728,
                        90
                    ],
                    [
                        970,
                        90
                    ]
                ]
            ],
            [
                [
                    1024,
                    1
                ],
                [
                    [
                        728,
                        90
                    ],
                    [
                        320,
                        50
                    ]
                ]
            ],
            [
                [
                    640,
                    1
                ],
                [
                    [
                        320,
                        50
                    ]
                ]
            ]
        ],
        targeting: {
            unitType: 'atf'
        }
    }), { advertIsOff  } = _useAdUnit, slotAttr = _object_without_properties(_useAdUnit, [
        "advertIsOff"
    ]);
    if (advertIsOff) {
        if (!isNsfgFallback) {
            return null;
        }
        return /*#__PURE__*/ React.createElement("div", {
            className: cn(adunitStyles['adhesion'], hidden && adunitStyles['hidden'])
        }, !hidden && /*#__PURE__*/ React.createElement("div", {
            style: {
                width: '728px',
                height: '90px'
            }
        }, /*#__PURE__*/ React.createElement(DealerAdIframe, {
            realEstateId: ADUNIT_FALLBACK_MAP['UserDesktopAdhesionGam'],
            neverCollapse: true,
            fillBlock: true
        })), /*#__PURE__*/ React.createElement(IconButton, {
            "aria-label": "Hide Advertisment",
            icon: Close,
            size: 'small',
            onClick: ()=>{
                setHidden(true);
            }
        }));
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: cn(adunitStyles['adhesion'], hidden && adunitStyles['hidden'])
    }, !hidden && /*#__PURE__*/ React.createElement("div", _extends({}, slotAttr)), /*#__PURE__*/ React.createElement(IconButton, {
        "aria-label": "Hide Advertisment",
        icon: Close,
        size: 'small',
        onClick: ()=>{
            setHidden(true);
        }
    }));
}, adunitMemo);
DesktopAdhesionGak.displayName = 'DesktopAdhesionGak';
export default DesktopAdhesionGak;
